<template>
    <div>
        <Form v-if="auth.regScreen === 'reg'" @submit.prevent="register()">
            <b-form-group>
                <Label for="firstName">First Name
                    <span class="text-danger">*</span></Label>
                <b-form-input required v-model="model.firstName" type="text" name="firstName" id="firstName"
                              placeholder="First Name here..."/>
            </b-form-group>
            <b-form-group>
                <Label for="lastName">Last Name
                    <span class="text-danger">*</span></Label>
                <b-form-input required v-model="model.lastName" type="text" name="lastName" id="lastName"
                              placeholder="Last Name here..."/>
            </b-form-group>
            <b-form-group>
                <Label for="exampleEmail">Email
                    <span class="text-danger">*</span>
                </Label>
                <b-form-input required v-model="model.email" type="email" name="email" id="exampleEmail"
                              placeholder="Email here..."/>
            </b-form-group>
            <b-form-group>
                <Label for="phone">Phone Number
                    <span class="text-danger">*</span></Label>
                <b-form-input required v-model="model.phone" type="text" name="phone" id="phone"
                              placeholder="Phone Number here..."/>
            </b-form-group>
            <b-form-group>
                <Label for="examplePassword">Pin
                    <span class="text-danger">*</span></Label>
<!--                <b-form-input  required v-model="model.password" maxlength="6" minlength="6" type="password" name="password" id="examplePassword"-->
<!--                              placeholder="Password here..."/>-->
                <the-mask placeholder="Kindly input 6 Digits..." type="password" required v-model="model.password" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />
            </b-form-group>
            <b-form-group>
                <Label for="examplePasswordRep">Repeat Pin
                    <span class="text-danger">*</span>
                </Label>
<!--                <b-form-input v-model="model.passwordConfirmation" maxlength="6"  minlength="6" type="password" name="passwordrep" id="examplePasswordRep"-->
<!--                              placeholder="Repeat Password here..."/>-->
                <the-mask placeholder="Repeat Pin here..." type="password" required v-model="model.passwordConfirmation" maxlength="6" minlength="6" :mask="['######', '######']" class="form-control" />
            </b-form-group>
<!--            <b-form-checkbox required name="check" id="exampleCheck">-->
<!--                Accept our <a href="javascript:void(0);" class="link-color">Terms and Conditions</a>.-->
<!--            </b-form-checkbox>-->
            <base-button
                    class="mt-2"
                    :loading="auth.authLoading"
                    title="Submit"
            ></base-button>
        </Form>

        <Form v-if="auth.regScreen === 'otp'" @submit.prevent="OTPVerification()">
            <b-form-group>
                <Label for="otp">
                    <span class="text-danger">*</span>
                    OTP
                </Label>
                <b-form-input maxlength="4" required v-model="model.token" type="text" name="otp" id="otp"
                              placeholder="OTP here..."/>
            </b-form-group>

            <div class="mt-4 d-flex align-items-center">
            </div>
            <base-button
                    class="mt-2"
                    :loading="auth.authLoading"
                    title="Submit"
            ></base-button>
        </Form>
    </div>
</template>

<script>
    import BaseButton from "../button/BaseButton";
    import {mapState} from  'vuex'
    export default {
        name: "RegisterForm",
        components:{BaseButton},
        data() {
            return {
                model: {
                    email: '',
                    firstName: '',
                    lastName: '',
                    pin: '1234',
                    password: '',
                    passwordConfirmation: '',
                    phone: '',
                    token: '',
                    username: '',
                    uniqueRef: '',
                    createAccount: 'YES',
                    countryCode: '234',
                    source: 'WEB'
                },
            }
        },
        methods: {
            async register() {
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch("auth/initiateEnrollment", this.model, { root: false });
                this.model.uniqueRef = this.auth.response.uniqueref;
                this.model.username = this.model.phone;
                // console.log(this.model)
                //console.log(this.auth.response);
            },

            async OTPVerification() {
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch("auth/completeEnrollment", this.model, { root: false })
                //if (this.auth.response.responsecode === '00') this.$router.push('/');
            },

            isNumberKey(evt){
                let charCode = (evt.which) ? evt.which : event.keyCode
                if (charCode > 31 && (charCode < 48 || charCode > 57))
                    return false;
                return true;
            }
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),
        }
    }
</script>

<style scoped>

</style>